module.exports = __webpack_public_path__ + "static/media/banner-photo1024@3x.f2a83c0e.webp";